import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { DamageEventDetailInterface } from '../definitions/damage-event-detail-interface';

@Injectable()
export class DamageEventDetailByIdService {

  private apiUrl = environment.rest.apiV2Url;

  public constructor(private client: HttpClient) {}

  public detail(id: string): Observable<DamageEventDetailInterface> {
    const url = `${this.apiUrl}/damage-events/${id}`;

    return this.client.get<DamageEventDetailInterface>(url).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
